export const boldText = "XGc";
export const italicText = "YGc";
export const underlineText = "ZGc";
export const bulletsText = "_Gc";
export const numberingText = "$Gc";
export const outdentText = "aHc";
export const indentText = "bHc";
export const blockQuoteText = "cHc";
export const alignLeftText = "dHc";
export const alignRightText = "eHc";
export const alignCenterText = "fHc";
export const superscriptText = "gHc";
export const subscriptText = "hHc";
export const strikethroughText = "iHc";
export const dirLtrText = "jHc";
export const dirRtlText = "kHc";
export const removeFormatText = "lHc";
export const undoText = "mHc";
export const redoText = "nHc";
export const formatPainterText = "oHc";
export const changeCaseText = "pHc";
export const uppercaseText = "qHc";
export const lowercaseText = "rHc";
export const capitalizeEachWordText = "sHc";
export const sentenceCaseText = "tHc";
export const fontColorText = "uHc";
export const moreColorsText = "vHc";
export const customColorsText = "wHc";
export const noColorText = "xHc";
export const highlightColorText = "yHc";
export const cutText = "zHc";
export const copyControlText = "AHc";
export const pasteText = "BHc";
export const fontNameText = "CHc";
export const fontSizeText = "DHc";
export default {boldText,italicText,underlineText,bulletsText,numberingText,outdentText,indentText,blockQuoteText,alignLeftText,alignRightText,alignCenterText,superscriptText,subscriptText,strikethroughText,dirLtrText,dirRtlText,removeFormatText,undoText,redoText,formatPainterText,changeCaseText,uppercaseText,lowercaseText,capitalizeEachWordText,sentenceCaseText,fontColorText,moreColorsText,customColorsText,noColorText,highlightColorText,cutText,copyControlText,pasteText,fontNameText,fontSizeText};